import * as React from 'react';

import {
  CalciteDatePicker,
  CalciteInput,
} from '@esri/calcite-components-react';
import { DomainCellEditor } from '../GridComponents/Editors/DomainCellEditor';

interface Props {
  type: OperatorType;
  value: FilterValue;
  domain?: IDomain;
  onChange: (value: FilterValue) => void;
}

export default function FilterInput({
  type,
  value,
  domain,
  onChange,
}: Props): JSX.Element {
  if (domain?.codedValues) {
    return (
      <DomainCellEditor
        domain={domain}
        value={value as string}
        onChange={onChange}
      />
    );
  }

  if (type === 'date') {
    const dateValue = value ? new Date(value) : new Date();
    return (
      <CalciteDatePicker
        scale="s"
        onCalciteDatePickerChange={(e) => {
          if (e.target.valueAsDate !== dateValue) {
            onChange(e.target.valueAsDate as Date);
          }
        }}
        valueAsDate={dateValue}
      />
    );
  }
  return (
    <CalciteInput
      value={value as string}
      type="text"
      scale="s"
      onCalciteInputInput={(e) => onChange(e.target.value)}
    />
  );
}
